module.exports = __webpack_public_path__ + "media/images/flags/PK-80eb91dc1d8c2873be63d3f03d5c7195.svg";